import {
  BASE_URL,
  EXTERNAL_APP_URL,
  WIDGETS_BASE_URL,
  AI_SCAN_URL,
} from "../constants/constants";
function apiClient(name) {
  const headers = { "Content-Type": "application/json" };
  var address = "";
  if (name === "external") {
    address = EXTERNAL_APP_URL;
  } else if (name === "base") {
    address = BASE_URL;
  } else if (name === "widgets") {
    address = WIDGETS_BASE_URL;
  } else if (name === "ai") {
    address = AI_SCAN_URL;
  }
  return {
    post: async function post(endpoint, credentials, authKey) {
      if (authKey) {
        headers["Authorization"] = authKey;
      }
      var response = await fetch(address + endpoint, {
        method: "POST",
        headers: headers,
        body: credentials ? JSON.stringify(credentials) : null,
      });
      var data = await response.json();
      return data;
    },
    get: async function get(endpoint, params) {
      var response = await fetch(
        address + endpoint + new URLSearchParams(params)
      );
      var data = await response.json();
      return data;
    },
  };
}

export default apiClient;
